import React from 'react';

import { displayAxiosError } from '@apis/next/errors';
import { Alert, AlertProps } from '@components/Alert';
import { makeMuiStyles } from '@styles';
import type { UseMutationResult } from '@tanstack/react-query';
import { FormError } from '@utils/errors';
import { createStrings } from '@utils/local';
import clsx from 'clsx';

const strings = createStrings({
  ja: {
    unknownError: 'エラーが発生しました。',
    saved: '入力した内容が保存されました。',
  },
});

const useStyles = makeMuiStyles((_theme, _common) => ({
  gutter: {
    marginBottom: '1rem',
  },
  marginTop: {
    marginTop: '1rem',
  },
}));

export interface FormAlertProps {
  mutation: UseMutationResult<any, any, any, any>;
  dataId?: string;
  showSuccess?: boolean;
  successMessage?: string | React.ReactNode;
  alertProps?: Partial<AlertProps>;
  marginTop?: boolean;
  gutter?: boolean;
}

export const FormAlert: React.FC<FormAlertProps> = (props) => {
  const {
    mutation: { isSuccess, isError, error, reset },
    dataId,
    showSuccess = false,
    successMessage,
    alertProps,
    marginTop,
    gutter,
  } = props;

  const classes = useStyles();

  const alertClasses = {
    container: clsx(
      gutter && classes.gutter,
      marginTop && classes.marginTop,
      alertProps?.classes?.container,
    ),
  };

  if (isError) {
    return (
      <Alert
        dataId={dataId}
        open
        severity="error"
        onClose={reset}
        {...alertProps}
        classes={alertClasses}
      >
        {displayAxiosError(error) ??
          ((error instanceof FormError ? error.getDisplayMessage() : (error as any)?.message) ||
            strings.unknownError)}
      </Alert>
    );
  }

  if (isSuccess && showSuccess) {
    return (
      <Alert
        dataId={dataId}
        open
        severity="success"
        onClose={reset}
        classes={alertClasses}
        {...alertProps}
      >
        {successMessage ?? strings.saved}
      </Alert>
    );
  }

  return <Alert open={false} severity="success" />;
};
